import React, { useEffect, useRef } from "react";
import {
  Field,
  Form,
  FormElement,
  FormRenderProps,
} from "@progress/kendo-react-form";
import { GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import FormTextField from "../../components/formFields/FormTextField";
import { requiredValidator } from "../../components/formFields/CommonValidator";
import FormSelectionField from "../../components/formFields/FormSelectionField";
import { Button } from "@progress/kendo-react-buttons";
import ButtonWithLoading from "../../components/common/ButtonWithLoading";
import { LoadingPanel } from "../../components/layout/Loading";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { STATUSARRAY } from "../../_contstants/common";
import { clearProcessDetails } from "./processSlice";
import {
  createProcess,
  getAllProcess,
  getItemProcessById,
  updateProcess,
} from "./services/process.services";
import { IProcess } from "./processModel";
import { closed } from "../../components/muidrawer/muiDrawerSlice";
import { Typography } from "@progress/kendo-react-common";
import { RxCross1 } from "react-icons/rx";
import FormRichTextField from "../../components/formFields/FormRichTextField";

const CreateProcess: React.FC = () => {
  const formLoading = useAppSelector((state) => state.process.formLoading);
  const ProcessDetail = useAppSelector((state) => state.process.ProcessDetail);
  const ProcessList = useAppSelector((state) => state.process.ProcessList);
  const process_guid = useAppSelector((state) => state.muidrawer.data);
  const dispatch = useAppDispatch();
  const gridRef = useRef<any>(null);

  useEffect(() => {
    return () => {
      dispatch(clearProcessDetails());
      dispatch(closed());
    };
  }, []);

  useEffect(() => {
    if (process_guid) {
      dispatch(getItemProcessById(process_guid));
    }
  }, [process_guid]);

  const handleSubmit = async (values: any) => {
    try {
      if (!process_guid) {
        const payload = {
          process_name: values.process_name,
          parent_process_id: values.parent_process_id
            ? +values.parent_process_id
            : null,
          // parent_process: values.parent_process,
          remarks: values.remarks,
          isactive: values.isactive === 1,
        };
        const response = await dispatch(createProcess(payload));
        if (response?.meta?.requestStatus === "fulfilled") {
          dispatch(closed());
          dispatch(clearProcessDetails());
          dispatch(getAllProcess());
        }
      } else {
        const payload = {
          process_guid: process_guid,
          process_name: values.process_name,
          parent_process_id: values.parent_process_id
            ? +values.parent_process_id
            : null,
          // parent_process: values.parent_process,
          remarks: values.remarks,
          isactive: values.isactive === 1,
        };
        const response = await dispatch(updateProcess(payload));
        if (response?.meta?.requestStatus === "fulfilled") {
          dispatch(closed());
          dispatch(clearProcessDetails());
          dispatch(getAllProcess());
        }
      }
    } catch (error) {
      console.error("Error in handleSubmit:", error);
      throw error;
    }
  };

  const handleFormClose = () => {
    dispatch(closed());
  };

  if (formLoading) return <LoadingPanel gridRef={gridRef} />;
  return (
    <Form
      onSubmit={handleSubmit}
      initialValues={ProcessDetail}
      render={(formRenderProps: FormRenderProps) => (
        <FormElement style={{ width: "100%" }}>
          <GridLayout
            style={{
              display: "flex",
              flexWrap: "wrap",
            }}
            gap={{ rows: 10 }}
            cols={[{ width: "100%" }]}
          >
            <GridLayoutItem
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                margin: "17px 0 8px",
              }}
            >
              <Typography.h4 className="m-0">
                {process_guid ? "Update Process" : "Add Process"}
              </Typography.h4>
              <Button
                type="button"
                fillMode={"flat"}
                themeColor={"dark"}
                style={{ marginRight: 4 }}
                onClick={() => dispatch(closed())}
              >
                <RxCross1 />
              </Button>
            </GridLayoutItem>
            <GridLayoutItem style={{ width: "100%" }}>
              <Field
                name="process_name"
                label="Process Name"
                placeholder="Process Name"
                component={FormTextField}
                validator={requiredValidator} astrike={true}
              />
            </GridLayoutItem>
            <GridLayoutItem style={{ width: "100%" }}>
              <Field
                name="parent_process_id"
                label="Parent Process"
                placeholder="Parent Process"
                component={FormSelectionField}
                options={ProcessList?.map((process: IProcess) => {
                  return {
                    value: process.id,
                    label: process.process_name,
                  };
                })}
              />
            </GridLayoutItem>
            <GridLayoutItem style={{ width: "100%" }}>
              <Field
                name="remarks"
                label="Remarks"
                placeholder="Remarks"
                component={FormRichTextField}
              />
            </GridLayoutItem>
            <GridLayoutItem style={{ width: "100%" }}>
              <Field
                id={"isactive"}
                name={"isactive"}
                label={"Status"}
                component={FormSelectionField}
                validator={requiredValidator} astrike={true}
                options={STATUSARRAY?.map((status: any) => {
                  return {
                    value: status.value,
                    label: status.label,
                  };
                })}
              />
            </GridLayoutItem>
            <GridLayoutItem
              colSpan={3}
              style={{
                textAlign: "start",
                marginTop: "20px",
                width: "100%",
              }}
            >
              <ButtonWithLoading
                label={process_guid ? "Update" : "Save"}
                type="submit"
                disabled={!formRenderProps.allowSubmit || formLoading}
                loading={formLoading}
              />
              <Button
                type="button"
                fillMode={"outline"}
                themeColor={"primary"}
                style={{ marginLeft: 4 }}
                onClick={handleFormClose}
              >
                Cancel
              </Button>
            </GridLayoutItem>
          </GridLayout>
        </FormElement>
      )}
    />
  );
};

export default CreateProcess;
